// B2B-side auth utils. Storage keys префиксованы `b2b-` чтобы не пересекаться с C2C
// (utils/auth.js) — оба продукта живут на одном домене и оба пишут в localStorage.
const TOKEN_KEY = 'b2b-auth-token';
const MEMBER_KEY = 'b2b-auth-member';
const WORKSPACE_KEY = 'b2b-auth-workspace';

export function getB2BAuthToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setB2BAuthSession({ token, member, workspace }) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(MEMBER_KEY, JSON.stringify(member));
    localStorage.setItem(WORKSPACE_KEY, JSON.stringify(workspace));
  } catch {
    /* storage quota or disabled */
  }
}

export function clearB2BAuthSession() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(MEMBER_KEY);
    localStorage.removeItem(WORKSPACE_KEY);
  } catch {
    /* ignore */
  }
}

export function getStoredB2BMember() {
  try {
    const raw = localStorage.getItem(MEMBER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getStoredB2BWorkspace() {
  try {
    const raw = localStorage.getItem(WORKSPACE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isB2BTokenExpired(token) {
  if (!token) return true;
  try {
    const [, payloadB64] = token.split('.');
    const payload = JSON.parse(atob(payloadB64.replace(/-/g, '+').replace(/_/g, '/')));
    if (!payload.exp) return false;
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
}

export function isB2BAuthenticated() {
  const token = getB2BAuthToken();
  return Boolean(token) && !isB2BTokenExpired(token);
}
